import { apiPath } from '../../constants';
import {
    axios,
    apiRequestOptions,
    transformHttpResponse,
} from 'utils';

export const ATTENDANCE_SAVE_SUCCESS = 'ATTENDANCE_SAVE_SUCCESS';

/**
 * Create (no id) or update (existing id) one athlete's attendance status.
 * Both the Check-In page and the category Attendance tab call this SAME
 * action — one Redux slice, so a change made from either place is
 * immediately visible in the other.
 *
 * Returns a promise the caller awaits for per-row save state; the resolved
 * result is also upserted into the attendance store. Rejection carries the
 * backend violation message when present — the row displays it inline.
 */
export const saveAttendance = ({ competitionId, sportsmanId, status, existingId = null, withdrawnCategories }) => {
    return function(dispatch) {
        // WHICH CATEGORIES a withdrawal is from — null for all of them
        // (8 Oct 2026). Sent only when the caller names it; any status but a
        // withdrawal clears it on the server.
        const scope = undefined === withdrawnCategories ? {} : { withdrawnCategories };
        const options = existingId
            ? apiRequestOptions(apiPath.ATTENDANCE.PATCH, { status, ...scope }, { params: { id: existingId } })
            : apiRequestOptions(apiPath.ATTENDANCE.POST, {
                competition: '/api/competitions/' + competitionId,
                sportsman: '/api/sportsmen/' + sportsmanId,
                status,
                ...scope,
            });

        return axios(options)
            .then(transformHttpResponse)
            .then(response => {
                dispatch({ type: ATTENDANCE_SAVE_SUCCESS, result: response.data, competitionId });
                return response.data;
            })
            .catch(rejectWithViolationMessage);
    }
};

const rejectWithViolationMessage = error => {
    const violations = error.response && error.response.data && error.response.data.violations;
    const message = (violations && violations.length && violations[0].message)
        || (error.response && error.response.data && error.response.data['hydra:description'])
        || (error.response && error.response.data && error.response.data.message)
        || 'Save failed';
    return Promise.reject(new Error(message));
};
